export const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#6366F1'];

// Stage colors for visual distinction
export const STAGE_COLORS = {
  // Prequalification
  'New': { bg: 'bg-blue-100', text: 'text-blue-700', border: 'border-blue-300' },
  'Submitted': { bg: 'bg-cyan-100', text: 'text-cyan-700', border: 'border-cyan-300' },
  'Pending': { bg: 'bg-amber-100', text: 'text-amber-700', border: 'border-amber-300' },
  'Enlisted': { bg: 'bg-green-100', text: 'text-green-700', border: 'border-green-300' },
  'Disqualified': { bg: 'bg-red-100', text: 'text-red-700', border: 'border-red-300' },

  // Proposal / Tender
  'In Process': { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-300' },
  'Won': { bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-300' },
  'Awarded': { bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-300' },
  'Lost': { bg: 'bg-rose-100', text: 'text-rose-700', border: 'border-rose-300' },
  'Hold': { bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-300' }
};

// Why a prequalification was lost — asked once, when the prequalification moves to Lost.
//
// `klass` is never shown to the salesperson; it exists so analytics can
// separate "this was never a real deal" from "we lost a real one". Win rate
// measured against every raw inquiry (spam, wrong numbers, silent prequalifications)
// understates the team badly; measured against qualified deals only, it
// answers the question an owner actually asks.
//
//   disqualified — never a genuine opportunity
//   lost         — a real deal that went elsewhere
//   nofault      — no deal to win; may come back
export const LOSS_REASON_CLASSES = ['lost', 'disqualified', 'nofault'];

export const LOSS_REASONS = [
  { id: 'price', label: 'Price / out of budget', klass: 'lost' },
  { id: 'competitor', label: 'Chose a competitor', klass: 'lost' },
  { id: 'date_unavailable', label: 'Date unavailable', klass: 'lost' },
  { id: 'out_of_area', label: 'Out of area', klass: 'lost' },
  { id: 'capacity', label: 'Capacity mismatch', klass: 'lost' },
  { id: 'other', label: 'Other', klass: 'lost' },
  { id: 'no_answer', label: 'Never answered / unreachable', klass: 'disqualified' },
  { id: 'not_serious', label: 'Just enquiring, not serious', klass: 'disqualified' },
  { id: 'invalid_contact', label: 'Invalid contact or spam', klass: 'disqualified' },
  { id: 'event_cancelled', label: 'Event cancelled', klass: 'nofault' },
  { id: 'postponed', label: 'Postponed to a later date', klass: 'nofault' }
];

export const LOSS_REASON_BY_ID = Object.fromEntries(LOSS_REASONS.map((r) => [r.id, r]));

// Reasons that mean "no genuine opportunity existed" — excluded from the
// qualified win rate.
export const DISQUALIFYING_REASONS = LOSS_REASONS.filter((r) => r.klass === 'disqualified').map((r) => r.id);




// Stale prequalification thresholds (in hours)
export const STALE_THRESHOLDS = {
  REMINDER: 24,    // Remind employee after 24 hours
  ESCALATE: 48     // Escalate/reassign after 48 hours
};




// Payment milestones
export const PAYMENT_MILESTONES = ['Advance', 'Mid-payment', 'Final payment'];

// Prequalification Types & Prequalification Constants
export const LEAD_TYPES = [
  { id: 'PREQUALIFICATION', label: 'Prequalification / Enlistment Details', icon: '📋' },
  { id: 'PROPOSAL_TENDER', label: 'Proposal / Tender Form', icon: '💼' }
];

;

export const DOCUMENT_STATUSES = [
  'To be Received',
  'In Process',
  'Submitted'
];

export const PREQUALIFICATION_STATUSES = [
  'New',
  'Submitted',
  'Pending',
  'Enlisted',
  'Disqualified'
];

export const AWARD_STATUSES = [
  'In Process',
  'Submitted',
  'Won',
  'Lost',
  'Hold'
];

export const PROFILE_STATUSES = [
  'New',
  'In Process',
  'Interested',
  'Hold',
  'Lost'
];

export const APPROVAL_STATUSES = [
  'PENDING_APPROVAL',
  'APPROVED',
  'REJECTED'
];

export const APPROVAL_STATUS_CONFIG = {
  'PENDING_APPROVAL': {
    label: 'Pending Approval',
    translationKey: 'pendingApproval',
    bg: 'bg-amber-100',
    text: 'text-amber-800',
    border: 'border-amber-300',
    badge: 'bg-amber-50 text-amber-700 ring-1 ring-amber-600/20'
  },
  'APPROVED': {
    label: 'Approved',
    translationKey: 'approved',
    bg: 'bg-emerald-100',
    text: 'text-emerald-800',
    border: 'border-emerald-300',
    badge: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-600/20'
  },
  'REJECTED': {
    label: 'Rejected',
    translationKey: 'rejected',
    bg: 'bg-rose-100',
    text: 'text-rose-800',
    border: 'border-rose-300',
    badge: 'bg-rose-50 text-rose-700 ring-1 ring-rose-600/20'
  }
};

export const ROLE_LABELS = {
  'CEO': 'CEO',
  'GM_Operations': 'GM Operations',
  'BM_Operations': 'GM Operations',
  'Senior_Team_Lead': 'Senior Team Lead',
  'Team_Lead': 'Team Lead',
  'Associate_Team_Lead': 'Associate Team Lead',
  'Associate': 'Associate Team Lead'
};

